export default __webpack_public_path__ + "static/media/green-bubbles.be720232.svg";